<script setup lang="ts">
import { computed } from 'vue';
import { useApi } from '../../app/api/index.ts';
import { useAsyncData } from '../../app/composables/useAsyncData.ts';

const api = useApi();
const { data, error, loading } = useAsyncData((signal) => api.health.get({ signal }));

const state = computed(() => {
  if (loading.value) return { tone: '', text: 'Checking…' };
  if (error.value) return { tone: 'status--error', text: 'API unreachable' };
  if (data.value?.status === 'ok')
    return { tone: 'status--ok', text: `API v${data.value.version}` };
  return { tone: 'status--warn', text: 'API degraded' };
});
</script>

<template>
  <span class="status" :class="state.tone" data-testid="api-status">{{ state.text }}</span>
</template>
